import Image from 'next/image';

import { AirIcon } from '@air/design-icons';
import { Portal } from '@air/primitive-portal';

import CatDoingThings from '~/assets/cat-doing-things.svg';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

type MaintenanceModeProps = {
  children: JSX.Element;
};

const AIR_LOGO_SIZE = 65;

export const MaintenanceMode = ({ children }: MaintenanceModeProps) => {
  const { maintenanceModeJson } = useFeatureFlags();

  // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the icon migration
  if (maintenanceModeJson?.maintenanceMessage) {
    return (
      <Portal>
        <div
          className="fixed top-0 left-0 z-10 flex size-full flex-col items-center gap-4 ads:bg-base bg-gray-1 px-8 pt-16"
          data-testid="MAINTENANCE_MODE_CONTAINER"
        >
          <AirIcon className="ads:text-icon-emphasis text-gray-12" size={AIR_LOGO_SIZE} />
          <Image alt="A cat doing things" src={CatDoingThings} height={220} unoptimized width={370} />
          <h1 className="mb-2 text-center font-semibold ads:text-primary text-32 text-gray-12 md:text-40">
            Air is currently unavailable
          </h1>
          <p className="max-w-screen-sm text-balance text-center ads:text-metadata text-20 text-gray-10">
            {maintenanceModeJson.maintenanceMessage}
          </p>
        </div>
      </Portal>
    );
  }

  return children;
};
